import { connect } from 'react-redux';

import Login from './Login';

const mapProps = state => ({
    isLoggedIn: state.auth.isLoggedIn,
    isSessionExpired: state.auth.isSessionExpired,
    isLoggedOut: state.auth.isLoggedOut,
    JWTError: state.auth.JWTError,
    LDAPError: state.auth.LDAPError,
    JWTLoading: state.auth.JWTLoading,
    LDAPLoading: state.auth.LDAPLoading,
    LDAPErrorMessage: state.auth.LDAPErrorMessage,
});

const mapDispatch = dispatch => ({
    JWTAuth: dispatch.auth.JWTAuth,
    LDAPAuth: dispatch.auth.LDAPAuth,
    setLoggedOut: dispatch.auth.setLoggedOut,
});

export default connect(mapProps, mapDispatch)(Login);
